import { Component, computed, input } from "@angular/core";
import { FieldTree } from "@angular/forms/signals";
import { ExpandableMinMaxFilterComponent, MinMaxFilterConfig } from "src/app/shared-components/expandable-min-max-filter/expandable-min-max-filter.component";
import { NumberOfBedroomFilterModel } from "./search-filter-numberofbedroom.model";

@Component({
    selector: "search-filter-numberofbedroom",
    imports: [ExpandableMinMaxFilterComponent],
    templateUrl: "./search-filter-numberofbedroom.component.html",
    styleUrl: "./search-filter-numberofbedroom.component.scss",
})
export class SearchFilterNumberOfBedroomComponent {
    filterForm = input.required<FieldTree<NumberOfBedroomFilterModel>>();
 
    protected filterConfig = computed<MinMaxFilterConfig<NumberOfBedroomFilterModel>>(() => ({
        filterForm: this.filterForm,
        title: "Antall soverom",
        fromFieldAccessor: (form) => form.numberOfBedroomFrom,
        toFieldAccessor: (form) => form.numberOfBedroomTo,
        expandedAccessor: (form) => form.expanded,
        fromFieldId: "numberOfBedroomFrom",
        toFieldId: "numberOfBedroomTo",
        cssClass: "price",
    }));
}
